import {
  CREATE_EDI_RECORD_REQUEST,
  CREATE_EDI_RECORD_SUCCESS,
  CREATE_EDI_RECORD_FAILURE,
  CLEAR_RECORD_CREATED_POPUP,
} from "../actionTypes";

const intialState = {
  loading: false,
  recordCreated: [],
  error: "",
};

const createRecordReducer = (state = intialState, action) => {
  switch (action.type) {
    case CREATE_EDI_RECORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_EDI_RECORD_SUCCESS:
      return {
        loading: false,
        recordCreated: action.payload,
        error: "",
      };
    case CLEAR_RECORD_CREATED_POPUP:
      return {
        ...state,
        recordCreated: [],
      };
    case CREATE_EDI_RECORD_FAILURE:
      return {
        loading: false,
        recordCreated: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export default createRecordReducer;
